(() => {
  let t, e, n, o, i, a = null, s = 65, c = new Set;
  const r = 1111;
  
  function d(t) { /* ... */ }
  function u(t) { /* ... */ }
  function l(t) { /* ... */ }
  function f(t) { /* ... */ }
  function h(t) { /* ... */ }
  function m(o) { /* ... */ }
  function p(t, e = "auto") { /* ... */ }

  (function () {
    if (!document.createElement("link").relList.supports("prefetch")) return;
    const o = "instantVaryAccept" in document.body.dataset || "Shopify" in window,
          i = navigator.userAgent.indexOf("Chrome/");
    if (i > -1) a = parseInt(navigator.userAgent.substring(i + "Chrome/".length));
    if (o && a && a < 110) return;

    const c = "instantMousedownShortcut" in document.body.dataset;
    t = "instantAllowQueryString" in document.body.dataset;
    e = "instantAllowExternalLinks" in document.body.dataset;
    n = "instantWhitelist" in document.body.dataset;

    const r = { capture: !0, passive: !0 };
    let f = !1, v = !1, g = !1;

    if ("instantIntensity" in document.body.dataset) {
      const t = document.body.dataset.instantIntensity;
      if (t.startsWith("mousedown")) {
        f = !0;
        if ("mousedown-only" == t) v = !0;
      } else if (t.startsWith("viewport")) {
        const e = navigator.connection && navigator.connection.saveData,
              n = navigator.connection && navigator.connection.effectiveType && navigator.connection.effectiveType.includes("2g");
        if (!e && !n) {
          if ("viewport" == t) document.documentElement.clientWidth * document.documentElement.clientHeight < 450000 && (g = !0);
          else if ("viewport-all" == t) g = !0;
        }
      } else {
        const e = parseInt(t);
        isNaN(e) || (s = e);
      }
    }

    v || document.addEventListener("touchstart", d, r);
    f ? c || document.addEventListener("mousedown", l, r) : document.addEventListener("mouseover", u, r);
    c && document.addEventListener("mousedown", h, r);

    if (g) {
      let t = window.requestIdleCallback;
      t || (t = t => { t() });
      t(function () {
        const t = new IntersectionObserver(e => {
          e.forEach(e => {
            if (e.isIntersecting) {
              const n = e.target;
              t.unobserve(n), p(n.href);
            }
          });
        });
        document.querySelectorAll("a").forEach(e => {
          m(e) && t.observe(e);
        });
      }, { timeout: 1500 });
    }
  })();
})();
